import Vue from 'vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import router from './router'
import store from './store'
import App from './App.vue'
import request from './apis'
import util from './assets/js/util'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/iconfont/iconfont.css'
import './assets/css/theme/blue/index.css'
import './assets/css/theme.scss'
import './assets/css/common.scss'
import './assets/css/component.scss'
import {message} from './assets/js/message'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(ElementUI)

Vue.prototype.$request = request
Vue.prototype.$util = util
Vue.prototype.$message = message

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js